var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":"","left-text":"返回","left-arrow":""},on:{"click-left":_vm.backJump},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"ellipsis"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }